<template>
  <v-card outlined>
    <v-toolbar dense flat>
      <v-toolbar-title>
        <v-text-field v-if='showSearch' hide-details single-line label='Search' prepend-icon='mdi-magnify'></v-text-field>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
          icon
          @click='archiveToggle'
          v-on='on'
          :color="showArchived ? 'red' : 'grey'">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        </template>
        <span>Show/hide deactivated</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on='on' @click='addClicked'><v-icon>mdi-plus</v-icon></v-btn>
        </template>
        <span>Add staff</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table
      :items='items'
      :headers='headers'
      :loading='isLoading'
    >
      <template v-slot:item.archived='{ item }'>
        {{ item }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'table-list',
  data () {
    return {
      showArchived: false
    }
  },
  props: {
    showSearch: {
      required: false,
      default: false
    },
    items: {
      required: true
    },
    showArchiveColumn: {
      required: false,
      default: false
    },
    headers: {
      required: true
    }
  },
  methods: {
    addClicked () {
      this.$emit('add')
    },
    archiveToggle () {
      this.showArchived = !this.showArchived
      this.$emit('toggleShowArchived', this.showArchived)
    }
  }
}
</script>
